import { DeepPartial, FormTruckComposition, VehicleByPlateModel } from '@/types';
import { getCityModelByAddressModel } from '../utils';
import { valueOrEmptyString } from '@/utils/string';
import { makeVehicleColorsList } from '@/data';

const getColor = (value?: string): string => {
  if (!value) return '';
  const color = makeVehicleColorsList().find((item) => RegExp(value, 'i').test(item));
  return color ?? '';
};

export const parseLoadVehicleByPlate = (data: DeepPartial<VehicleByPlateModel>): DeepPartial<FormTruckComposition> => ({
  brand: valueOrEmptyString(data.brand),
  chassis: valueOrEmptyString(data.chassis),
  color: getColor(valueOrEmptyString(data.color)),
  location: getCityModelByAddressModel(data),
  model: valueOrEmptyString(data.model),
  modelYear: valueOrEmptyString(data.modelYear),
  monofactureYear: valueOrEmptyString(data.productionYear),
  plate: valueOrEmptyString(data.plate),
  renavam: valueOrEmptyString(data.renavam),
  typeId: valueOrEmptyString(data.body?.id),
  typeName: valueOrEmptyString(data.body?.name),
  owner: {
    cpfCnpj: valueOrEmptyString(data.owner?.document),
  },
});
